import styles from './RichTextEditor.module.scss';

const theme = {
  paragraph: styles.editorParagraph,
  text: {
    bold: styles.textBold,
    italic: styles.textItalic,
    underline: styles.textUnderline,
    strikethrough: styles.textStrikethrough,
  },
  heading: {
    h1: styles.headingH1,
    h2: styles.headingH2,
    h3: styles.headingH3,
  },
  quote: styles.quote,
  list: {
    check: styles.checklist,
    listitem: styles.listItem,
  },
  link: styles.link,
  table: styles.table,
  tableCell: styles.tableCell,
  tableCellHeader: styles.tableCellHeader,
  tableCellSelected: styles.tableCellSelected,
  tableSelected: styles.tableSelected,
  format: {
    left: styles.alignLeft,
    center: styles.alignCenter,
    right: styles.alignRight,
    justify: styles.alignJustify,
  },
};

export default theme;
